import { getConventionalMode, getMappingDataApiHandler, mapBatchConventionalMode, mapConventionalMode } from "../../../services/api/apiHandler" 
import { socket } from "../../../services/socket/socket";

export const fetchConventionalMode = (project_id, tb_id, page = 1, limit = 100, filters = null, groupingStatus = null) => {
    return dispatch => {
        dispatch({type:"CM_ACTION_START"})      
        console.log("here fetchConventionalMode");
        const requestParams = { projectID: project_id, page, limit };
        if (filters) {
            requestParams.filters = JSON.stringify(filters);
        }
        if (groupingStatus) {
            requestParams.groupingStatus = groupingStatus;
        }
        getMappingDataApiHandler(requestParams).then((result)=>{
            console.log("MAPPING API RESPONSE:", result?.data);
            const paginationData = result?.data?.pagination || result?.data?.data?.pagination;
            const mappingData={
                data:{line_items:result?.data?.line_items || []},
                cy_balance:0,
                py_balance:0,
                records:result?.data?.line_items?.length || 0,
                status:result?.data?.success,
            }
            dispatch({
                type: "CM_FETCH_DATA",
                payload: {
                  data: mappingData, 
                  set_payload: JSON.stringify({project_id, tb_id}),
                  pagination: paginationData,
                  activeFilters: filters
                }
            });
        }).catch((err)=>{
            dispatch({
                type:"CM_FETCH_DATA_FAILED",
                payload: err.response?.data?.error || err.message || "An unexpected error occurred"
            })
        }) 
    }
}


export const updateConventionalMode = (setPayload, updatedData) => {
    return dispatch => {
        const {project_id, tb_id} = JSON.parse(setPayload);
        return mapConventionalMode(project_id, tb_id, {updatedData}).then((response)=>{
            dispatch({
                type: "CM_UPDATING_DATA",
                payload: {data: response.data.data.line_items || []}
            });
            socket.emit("request-balance-sheet", {project_id, tb_id});
            socket.emit("request-mapped-grouping", {project_id, tb_id});
            socket.emit("request-pnl-statement", {project_id, tb_id});
            return response;
        }).catch((err)=>{
            dispatch({
                type:"CM_FETCH_DATA_FAILED",
                payload: err.response?.data?.message || err.message
            });
            throw err;
        });
    }
}

export const batchUpdateConventionalMode = (setPayload, updatedData) => {
    return dispatch => {
        const {project_id, tb_id} = JSON.parse(setPayload);
        return mapBatchConventionalMode(project_id, tb_id, {updatedData}).then((response)=>{
            dispatch({
                type: "CM_UPDATING_DATA",
                payload: {data: response.data.data.line_items || []}
            });
            socket.emit("request-balance-sheet", {project_id, tb_id})
            socket.emit("request-mapped-grouping", {project_id, tb_id})
            socket.emit("request-pnl-statement", {project_id, tb_id})
        }).catch((err)=>{
            dispatch({
                type:"CM_FETCH_DATA_FAILED",
                payload: err.response?.data?.message || err.message || "An unexpected error occurred"
            })
        })
    }
}

export const deleteLineItems = (deletedItems, project_id, tb_id) => {
    return dispatch => {
        dispatch({
            type: "CM_DELETE_LINE_ITEM",
            payload: {data: deletedItems}
        });
        socket.emit("request-balance-sheet", {project_id, tb_id})
        socket.emit("request-mapped-grouping", {project_id, tb_id})
        socket.emit("request-pnl-statement", {project_id, tb_id})
    }
}

export const restoreLineItems = (restoreData, project_id, tb_id) => {
    return dispatch => {
        dispatch({
            type: "CM_RESTORE_LINE_ITEM",
            payload: {data: restoreData}
        });
        socket.emit("request-balance-sheet", {project_id, tb_id})
        socket.emit("request-mapped-grouping", {project_id, tb_id})
        socket.emit("request-pnl-statement", {project_id, tb_id})
    }
}

export const restoreMultiLineItems = (project_id, tb_id) => {
    return dispatch => {
        socket.emit("request-balance-sheet", {project_id, tb_id})
        socket.emit("request-mapped-grouping", {project_id, tb_id})
        socket.emit("request-pnl-statement", {project_id, tb_id})
    }
}

export const addFilterLineItems = (filterDatas) => {
    return dispatch => {
        dispatch({
            type: "CM_FILTERED_LINE_ITEM",
            payload: {data:filterDatas}
        })
    }
}

export const socketCMUpdate = (response, payload) => {
    return dispatch => {
        dispatch({
            type: "CM_SOCKET_UPDATE_DATA", 
            payload: { 
                data: response, 
                set_payload: payload 
            }
        })
    }
}
